import React from 'react'

const ExerciseDetails = () => {
  return (
    <div>ExerciseDetails</div>
  )
}

export default ExerciseDetails